import React from 'react';
import styles from './RecruitmentPage.module.css';

const RecruitmentPage: React.FC = () => {
  return (
    <div className={styles.recruitmentPage}>
      <div className={styles.container}>
        {/* 상단 강조 배너 */}
        <div className={styles.headerBanner}>
          <div className={styles.bannerBadge}>직원모집</div>
          <h1 className={styles.mainTitle}>검사원 모집</h1>
          <p className={styles.subtitle}>승강기 검사원을 모집합니다</p>
        </div>

        {/* 지원 방법 */}
        <section className={styles.contactSection}>
          <h2 className={styles.sectionTitle}>지원 방법</h2>
          <div className={styles.contactGrid}>
            <div className={styles.contactBox}>
              <img src="/images/icon-email.svg" alt="이메일" className={styles.contactIcon} />
              <h3>이메일 접수</h3>
              <a href="mailto:kesti2026@daum.net" className={styles.contactLink}>
                kesti2026@daum.net
              </a>
            </div>
            <div className={styles.contactBox}>
              <img src="/images/icon-phone.svg" alt="전화" className={styles.contactIcon} />
              <h3>전화 연락</h3>
              <a href="tel:010-5142-6867" className={styles.contactLink}>
                  010-5142-6867
              </a>
            </div>
          </div>
        </section>

        {/* 채용분야 및 자격요건 - 이미지로 표시 */}
        <section className={styles.qualificationSection}>
          <h2 className={styles.sectionTitle}>채용분야 및 자격요건</h2>
          <div className={styles.imageWrapper}>
            <img
              src="/images/recruitment-qualification-table.jpg"
              alt="채용분야 및 자격요건"
              className={styles.qualificationImage}
            />
          </div>
          <div className={styles.note}>
            ※ 수습 기간으로 최장 3개월을 둘 수 있으며, 평가 후 결격사유가 없을 경우 채용 진행
          </div>
        </section>

        {/* 하단 지원 안내 */}
        <section className={styles.applySection}>
          <div className={styles.applyContent}>
            <p className={styles.applyText}>
              자격요건을 확인하시고 이력서와 자기소개서를 첨부하여 지원해주세요.
            </p>
            <div className={styles.applyButtons}>
              <a href="mailto:kesti2026@daum.net" className={styles.applyButton}>
                <img src="/images/icon-email.svg" alt="" className={styles.buttonIcon} />
                이메일로 지원하기
              </a>
              <a href="tel:010-5142-6867" className={styles.applyButtonSecondary}>
                <img src="/images/icon-phone.svg" alt="" className={styles.buttonIcon} />
                전화 문의하기
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default RecruitmentPage;
